module.exports = __webpack_public_path__ + "img/result-y8.3287ce29.png";